const ProjectFacilities = ({ facilities = [] }) => {
  if (!facilities.length) return null;

  // Determine number of columns dynamically
  const getColumnCount = () => {
    if (facilities.length <= 8) return 1;
    if (facilities.length <= 16) return 2;
    return 3;
  };

  const columns = getColumnCount();
  const itemsPerColumn = Math.ceil(facilities.length / columns);

  // Split into columns
  const facilityColumns = Array.from({ length: columns }, (_, i) =>
    facilities.slice(i * itemsPerColumn, (i + 1) * itemsPerColumn)
  );

  return (
    <div className="w-full ">
      <div className="p-6 lg:p-8 bg-white rounded-lg border">
        {/* Heading */}
        <h2 className="font-medium text-[#031722] tracking-[0.01em] text-[24px] mb-4">
          Project Facilities
        </h2>

        {/* Divider */}
        <div className="border-b-2 mb-4"></div>

        {/* Dynamic Columns Layout */}
        <div
          className={`grid grid-cols-1 md:grid-cols-${columns} gap-6 lg:gap-10`}
        >
          {facilityColumns.map((column, colIndex) => (
            <ul key={colIndex} className="space-y-3">
              {column.map((fac, idx) => (
                <li key={idx} className="flex gap-3">
                  <span className="font-normal text-[#858585] tracking-[0.01em] text-[16px]">
                    •
                  </span>
                  <span className="font-normal text-[#858585] tracking-[0.01em] text-[16px]">
                    {fac}
                  </span>
                </li>
              ))}
            </ul>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProjectFacilities;
